import React, { useState } from 'react';
import { Button } from './ui/button';
import { Clock, X } from 'lucide-react';

const PontoPWATest = () => {
  const [showModal, setShowModal] = useState(false);

  console.log('RENDER TEST: showModal =', showModal);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 to-indigo-900 p-4">
      <div className="text-center py-8">
        <h1 className="text-white text-4xl font-bold mb-8">PWA TEST</h1>
        
        <Button
          onClick={() => {
            console.log('CLIQUE TEST: Abrindo modal');
            setShowModal(true);
          }}
          className="w-full h-20 text-2xl font-bold bg-white bg-opacity-20 text-white"
        >
          <Clock className="h-8 w-8 mr-4" />
          TESTE MODAL
        </Button>
      </div>

      {/* Modal de Teste */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl w-full max-w-md p-6">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-2xl font-bold text-gray-900">MODAL FUNCIONANDO!</h2>
              <Button
                onClick={() => setShowModal(false)}
                variant="ghost"
                size="sm"
              >
                <X className="h-5 w-5" />
              </Button>
            </div>
            
            <div className="space-y-4">
              <p className="text-gray-600">Se você está vendo isso, o modal está funcionando perfeitamente!</p>
              
              <div className="grid grid-cols-2 gap-3">
                <Button className="bg-green-500 text-white">ENTRADA</Button>
                <Button className="bg-red-500 text-white">SAÍDA</Button>
                <Button className="bg-yellow-500 text-white">INTERVALO</Button>
                <Button className="bg-blue-500 text-white">RETORNO</Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PontoPWATest;